import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Flex, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
const BackNavigation = ({ heading, subHeading, bgColor = "#111111", showBackButton = true, showBorder, }) => {
    const navigate = useNavigate();
    const goBack = () => {
        if (!window.history || window.history.length <= 1) {
            navigate("/home");
        }
        else {
            navigate(-1);
        }
    };
    return (_jsx(Flex, { w: ["100vw", "100vw", "100vw", "400px"], h: "75px", p: 4, pt: 6, position: "fixed", left: [0, 0, 0, "calc((100% - 400px)/ 2)"], background: bgColor, zIndex: 10, alignItems: "center", justifyContent: "space-between", borderBottom: showBorder ? "1px solid #232323" : "none", children: _jsxs(Flex, { alignItems: "center", flex: 1, minW: 0, children: [showBackButton && (_jsx(ArrowBackIcon, { color: "white", fontSize: "2xl", cursor: "pointer", onClick: goBack })), _jsxs(VStack, { ml: 4, alignItems: "flex-start", justifyContent: "flex-start", spacing: 1, flex: 1, minW: 0, children: [_jsx(Text, { color: "white", fontSize: "md", fontWeight: 600, noOfLines: 1, children: heading }), _jsx(Text, { color: "#9D9D9D", fontSize: "xs", fontWeight: 400, noOfLines: 1, children: subHeading })] })] }) }));
};
export default BackNavigation;
